import vtkFullScreenRenderWindow from './FullScreenRenderWindow';
import vtkGenericRenderWindow from './GenericRenderWindow';
import vtkRenderWindowWithControlBar from './RenderWindowWithControlBar';
import vtkSynchronizableRenderWindow from './SynchronizableRenderWindow';

export default {
  vtkFullScreenRenderWindow,
  vtkGenericRenderWindow,
  vtkRenderWindowWithControlBar,
  vtkSynchronizableRenderWindow,
};
